/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { useSiteData } from "../context/SiteDataContext";
import staticData from "../data/pricing.json";

const Pricing = ({ isBg }) => {
  const { data: siteData, loading } = useSiteData();
  
  // Use context data if available, fallback to static
  const staticPricing = staticData.pricing;
  const bookPricing = siteData?.bookPricing || [];
  
  // Use dynamic pricing config or fallback to static
  const pricing = siteData?.pricingConfig || staticPricing;

  if (loading) {
    return (
      <section id="pricing" className="section-padding pricing">
        <div className="container"><p>Chargement...</p></div>
      </section>
    );
  }

  return (
    <section
      id="pricing"
      className={`section-padding pricing ${isBg === "yes" ? "bg-one" : ""}`}
    >
      <div className="container">
        <div className="row">
          <div className="col-xl-6 offset-xl-3 col-lg-10 offset-lg-1">
            <div className="section-title-center text-center">
              <span>{pricing.subtitle}</span>
              <h2 className="display-6">{pricing.title}</h2>
              <div className="section-divider divider-traingle"></div>
            </div>
          </div>
        </div>
        
        {/* Book Pricing Blocks */}
        {bookPricing.length > 0 && (
          <div className="row justify-content-center">
            {bookPricing.map((book, bookIndex) => (
              <div
                key={book.id || bookIndex}
                className="col-lg-6 col-xl-5 mb-4"
                data-aos="fade-up"
                data-aos-duration="1000"
                data-aos-delay={bookIndex * 100}
              >
                <div className="book-pricing-block translateEffect1">
                  <h3 className="book-pricing-block__title">{book.bookTitle}</h3>
                  
                  <div className="book-pricing-block__formats">
                    {/* E-Book */}
                    <div className="book-pricing-block__format">
                      <div className="format-info">
                        <span className="format-icon">📱</span>
                        <span className="format-name">E-Book</span>
                      </div>
                      <div className="format-price-action">
                        <span className="format-price">{book.ebookPrice}</span>
                        {book.ebookLink && (
                          <a
                            href={book.ebookLink}
                            target="_blank"
                            rel="noreferrer"
                            className="button button__primary button__sm"
                          >
                            <span>{book.btnText || 'Acheter'}</span>
                          </a>
                        )}
                      </div>
                    </div>
                    
                    {/* Livre broché */}
                    <div className="book-pricing-block__format">
                      <div className="format-info">
                        <span className="format-icon">📖</span>
                        <span className="format-name">Livre broché</span>
                      </div>
                      <div className="format-price-action">
                        <span className="format-price">{book.brochePrice}</span>
                        {book.brocheLink && (
                          <a
                            href={book.brocheLink}
                            target="_blank"
                            rel="noreferrer"
                            className="button button__primary button__sm"
                          >
                            <span>{book.btnText || 'Acheter'}</span>
                          </a>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default Pricing;
